import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const ArrowDown = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="73" viewBox="0 0 73 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2673 0.218594H56.2548V46.5337H72.9443L36.7609 80.0828L0.57663 46.5337H17.2673V0.218594Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
